import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export interface SignupFieldValues {
  firstName: string;
  lastName: string;
  username: string;
  phone: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
}

interface SignupFieldsProps {
  values: SignupFieldValues;
  onChange: (patch: Partial<SignupFieldValues>) => void;
}

const SignupFields = ({ values, onChange }: SignupFieldsProps) => {
  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="firstName">First Name *</Label>
          <Input
            id="firstName"
            type="text"
            placeholder="John"
            value={values.firstName}
            onChange={(e) => onChange({ firstName: e.target.value })}
            required
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="lastName">Last Name *</Label>
          <Input
            id="lastName"
            type="text"
            placeholder="Doe"
            value={values.lastName}
            onChange={(e) => onChange({ lastName: e.target.value })}
            required
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="username">Username (optional)</Label>
        <Input
          id="username"
          type="text"
          placeholder="johndoe"
          value={values.username}
          onChange={(e) => onChange({ username: e.target.value })}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="phone">Phone Number *</Label>
        <Input
          id="phone"
          type="tel"
          placeholder="1234567890"
          value={values.phone}
          onChange={(e) => onChange({ phone: e.target.value.replace(/\D/g, "") })}
          required
          maxLength={10}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="streetAddress">Street Address *</Label>
        <Input
          id="streetAddress"
          type="text"
          placeholder="123 Main St"
          value={values.streetAddress}
          onChange={(e) => onChange({ streetAddress: e.target.value })}
          required
          className="mt-1"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="city">City *</Label>
          <Input
            id="city"
            type="text"
            placeholder="New York"
            value={values.city}
            onChange={(e) => onChange({ city: e.target.value })}
            required
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor="state">State *</Label>
          <Input
            id="state"
            type="text"
            placeholder="NY"
            value={values.state}
            onChange={(e) => onChange({ state: e.target.value.toUpperCase() })}
            required
            maxLength={2}
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="zipCode">Zip Code *</Label>
        <Input
          id="zipCode"
          type="text"
          placeholder="12345"
          value={values.zipCode}
          onChange={(e) => onChange({ zipCode: e.target.value.replace(/\D/g, "") })}
          required
          maxLength={5}
          className="mt-1"
        />
      </div>
    </>
  );
};

export default SignupFields;
